var map = {
	"./static/icons/suo_on.png": "c86c",
	"./static/icons/suo_un.png": "8002",
	"./static/imagev2/Africa/AO.png": "cae1",
	"./static/imagev2/Africa/BF.png": "aea0",
	"./static/imagev2/Africa/BI.png": "82b9",
	"./static/imagev2/Africa/BJ.png": "72c0",
	"./static/imagev2/Africa/BW.png": "ece8",
	"./static/imagev2/Africa/CF.png": "d433",
	"./static/imagev2/Africa/CG.png": "8232",
	"./static/imagev2/Africa/CI.png": "dbe4",
	"./static/imagev2/Africa/CM.png": "193e",
	"./static/imagev2/Africa/CV.png": "1af7",
	"./static/imagev2/Africa/DJ.png": "5c79",
	"./static/imagev2/Africa/DZ.png": "79d0",
	"./static/imagev2/Africa/EG.png": "a281",
	"./static/imagev2/Africa/EH.png": "a868",
	"./static/imagev2/Africa/ER.png": "6652",
	"./static/imagev2/Africa/ET.png": "bd9c",
	"./static/imagev2/Africa/GA.png": "b9d1",
	"./static/imagev2/Africa/GH.png": "84dd",
	"./static/imagev2/Africa/GM.png": "68d8",
	"./static/imagev2/Africa/GN.png": "b127",
	"./static/imagev2/Africa/GQ.png": "954f",
	"./static/imagev2/Africa/GW.png": "33ab",
	"./static/imagev2/Africa/KE.png": "b413",
	"./static/imagev2/Africa/KM.png": "4c2d",
	"./static/imagev2/Africa/LR.png": "7bc5",
	"./static/imagev2/Africa/LS.png": "f433",
	"./static/imagev2/Africa/LY.png": "631c",
	"./static/imagev2/Africa/MA.png": "c75b",
	"./static/imagev2/Africa/MG.png": "dac7",
	"./static/imagev2/Africa/ML.png": "8690",
	"./static/imagev2/Africa/MR.png": "c474",
	"./static/imagev2/Africa/MU.png": "8bdb",
	"./static/imagev2/Africa/MW.png": "3fff",
	"./static/imagev2/Africa/MZ.png": "932b",
	"./static/imagev2/Africa/NA.png": "adca",
	"./static/imagev2/Africa/NE.png": "abcc",
	"./static/imagev2/Africa/NG.png": "8611",
	"./static/imagev2/Africa/RW.png": "4b04",
	"./static/imagev2/Africa/SC.png": "7df2",
	"./static/imagev2/Africa/SD.png": "cd2d",
	"./static/imagev2/Africa/SL.png": "92b7",
	"./static/imagev2/Africa/SN.png": "4e1e",
	"./static/imagev2/Africa/SO.png": "266f",
	"./static/imagev2/Africa/SS.png": "ae55",
	"./static/imagev2/Africa/ST.png": "83c0",
	"./static/imagev2/Africa/SZ.png": "ff78",
	"./static/imagev2/Africa/TD.png": "4d69",
	"./static/imagev2/Africa/TG.png": "0ac4",
	"./static/imagev2/Africa/TN.png": "483e",
	"./static/imagev2/Africa/TZ.png": "70c3",
	"./static/imagev2/Africa/UG.png": "e27d",
	"./static/imagev2/Africa/ZA.png": "17d9",
	"./static/imagev2/Africa/ZM.png": "226d",
	"./static/imagev2/Africa/ZW.png": "6ae4",
	"./static/imagev2/Asia/AE.png": "01e1",
	"./static/imagev2/Asia/AF.png": "70e0",
	"./static/imagev2/Asia/AM.png": "cfc1",
	"./static/imagev2/Asia/AZ.png": "3f81",
	"./static/imagev2/Asia/BD.png": "cf1a",
	"./static/imagev2/Asia/BH.png": "d612",
	"./static/imagev2/Asia/BN.png": "9d4f",
	"./static/imagev2/Asia/BT.png": "8df9",
	"./static/imagev2/Asia/CN.png": "7654",
	"./static/imagev2/Asia/HK.png": "e7ce",
	"./static/imagev2/Asia/ID.png": "3abd",
	"./static/imagev2/Asia/IL.png": "3675",
	"./static/imagev2/Asia/IN.png": "6825",
	"./static/imagev2/Asia/IQ.png": "dad8",
	"./static/imagev2/Asia/IR.png": "b84d",
	"./static/imagev2/Asia/JO.png": "5dc0",
	"./static/imagev2/Asia/JP.png": "385e",
	"./static/imagev2/Asia/KG.png": "01cc",
	"./static/imagev2/Asia/KH.png": "862c",
	"./static/imagev2/Asia/KP.png": "f534",
	"./static/imagev2/Asia/KR.png": "9dd6",
	"./static/imagev2/Asia/KW.png": "4ac7",
	"./static/imagev2/Asia/KZ.png": "c776",
	"./static/imagev2/Asia/LA.png": "453b",
	"./static/imagev2/Asia/LB.png": "4602",
	"./static/imagev2/Asia/LK.png": "7a0a",
	"./static/imagev2/Asia/MM.png": "ab5f",
	"./static/imagev2/Asia/MN.png": "392f4",
	"./static/imagev2/Asia/MO.png": "13bc",
	"./static/imagev2/Asia/MV.png": "d648",
	"./static/imagev2/Asia/MY.png": "9d66",
	"./static/imagev2/Asia/NP.png": "8726",
	"./static/imagev2/Asia/OM.png": "f2da",
	"./static/imagev2/Asia/PH.png": "c842",
	"./static/imagev2/Asia/PK.png": "42fa",
	"./static/imagev2/Asia/PS.png": "58da",
	"./static/imagev2/Asia/QA.png": "3808",
	"./static/imagev2/Asia/SA.png": "bcfc",
	"./static/imagev2/Asia/SG.png": "c2be",
	"./static/imagev2/Asia/SY.png": "9bde",
	"./static/imagev2/Asia/TH.png": "cd8f",
	"./static/imagev2/Asia/TJ.png": "f666",
	"./static/imagev2/Asia/TL.png": "b0ba",
	"./static/imagev2/Asia/TM.png": "7cdb",
	"./static/imagev2/Asia/TW.png": "c5f9",
	"./static/imagev2/Asia/UZ.png": "ac59",
	"./static/imagev2/Asia/VN.png": "ac51",
	"./static/imagev2/Asia/VU.png": "b509",
	"./static/imagev2/Asia/YE.png": "f2c8",
	"./static/imagev2/Europe/AD.png": "2a3a",
	"./static/imagev2/Europe/AI.png": "b341",
	"./static/imagev2/Europe/AL.png": "7352",
	"./static/imagev2/Europe/AT.png": "6973",
	"./static/imagev2/Europe/AX.png": "741b",
	"./static/imagev2/Europe/BA.png": "f1f7",
	"./static/imagev2/Europe/BE.png": "0fb5",
	"./static/imagev2/Europe/BG.png": "6815",
	"./static/imagev2/Europe/BY.png": "641d",
	"./static/imagev2/Europe/CH.png": "3312",
	"./static/imagev2/Europe/CY.png": "5109",
	"./static/imagev2/Europe/CZ.png": "608b",
	"./static/imagev2/Europe/DE.png": "9343",
	"./static/imagev2/Europe/DK.png": "d935",
	"./static/imagev2/Europe/EE.png": "3d00",
	"./static/imagev2/Europe/ES.png": "79ce",
	"./static/imagev2/Europe/FI.png": "a572",
	"./static/imagev2/Europe/FO.png": "d727",
	"./static/imagev2/Europe/FR.png": "7cf2",
	"./static/imagev2/Europe/GB.png": "3838",
	"./static/imagev2/Europe/GE.png": "94be",
	"./static/imagev2/Europe/GG.png": "a670",
	"./static/imagev2/Europe/GI.png": "04cd",
	"./static/imagev2/Europe/GR.png": "e99f",
	"./static/imagev2/Europe/HR.png": "7a76",
	"./static/imagev2/Europe/HU.png": "52ba",
	"./static/imagev2/Europe/IE.png": "908d",
	"./static/imagev2/Europe/IM.png": "397f",
	"./static/imagev2/Europe/IS.png": "59d8",
	"./static/imagev2/Europe/IT.png": "a02f",
	"./static/imagev2/Europe/LI.png": "c5f7",
	"./static/imagev2/Europe/LT.png": "8f1c",
	"./static/imagev2/Europe/LU.png": "af80",
	"./static/imagev2/Europe/LV.png": "7284",
	"./static/imagev2/Europe/MC.png": "092c",
	"./static/imagev2/Europe/MD.png": "6d78",
	"./static/imagev2/Europe/ME.png": "a6a0",
	"./static/imagev2/Europe/MK.png": "fd5b",
	"./static/imagev2/Europe/MT.png": "bbe2",
	"./static/imagev2/Europe/NL.png": "c690",
	"./static/imagev2/Europe/NO.png": "ce5f",
	"./static/imagev2/Europe/PL.png": "d0a3",
	"./static/imagev2/Europe/PT.png": "8e56",
	"./static/imagev2/Europe/RO.png": "8e0d",
	"./static/imagev2/Europe/RS.png": "5d1a",
	"./static/imagev2/Europe/RU.png": "c736",
	"./static/imagev2/Europe/SE.png": "75b8",
	"./static/imagev2/Europe/SI.png": "8ca6",
	"./static/imagev2/Europe/SK.png": "6547",
	"./static/imagev2/Europe/SM.png": "5d3c",
	"./static/imagev2/Europe/SX.png": "8641",
	"./static/imagev2/Europe/TR.png": "19cb",
	"./static/imagev2/Europe/UA.png": "9e26",
	"./static/imagev2/Europe/VA.png": "a8ba",
	"./static/imagev2/North America/AG.png": "d72b",
	"./static/imagev2/North America/AW.png": "b8c4",
	"./static/imagev2/North America/BB.png": "f4b2",
	"./static/imagev2/North America/BM.png": "c782",
	"./static/imagev2/North America/BS.png": "ccc3",
	"./static/imagev2/North America/BZ.png": "b30c",
	"./static/imagev2/North America/CA.png": "361f",
	"./static/imagev2/North America/CR.png": "8077",
	"./static/imagev2/North America/CU.png": "b6cb",
	"./static/imagev2/North America/CW.png": "fbb4",
	"./static/imagev2/North America/DM.png": "350a",
	"./static/imagev2/North America/DO.png": "aaf3",
	"./static/imagev2/North America/GD.png": "6013",
	"./static/imagev2/North America/GL.png": "b44fb",
	"./static/imagev2/North America/GP.png": "33c4",
	"./static/imagev2/North America/GT.png": "1aac",
	"./static/imagev2/North America/HN.png": "f15e",
	"./static/imagev2/North America/HT.png": "a38c",
	"./static/imagev2/North America/JM.png": "60cf",
	"./static/imagev2/North America/KY.png": "540c",
	"./static/imagev2/North America/LC.png": "3182",
	"./static/imagev2/North America/MQ.png": "c058",
	"./static/imagev2/North America/MX.png": "7d1f",
	"./static/imagev2/North America/NI.png": "722e",
	"./static/imagev2/North America/PA.png": "89e9",
	"./static/imagev2/North America/PR.png": "b55c",
	"./static/imagev2/North America/SV.png": "686d",
	"./static/imagev2/North America/TT.png": "2a63",
	"./static/imagev2/North America/US.png": "3362",
	"./static/imagev2/North America/VG.png": "2311",
	"./static/imagev2/North America/VI.png": "ce18",
	"./static/imagev2/Oceania/AS.png": "40cc",
	"./static/imagev2/Oceania/AU.png": "33a0",
	"./static/imagev2/Oceania/CK.png": "e9ca",
	"./static/imagev2/Oceania/FJ.png": "83f4",
	"./static/imagev2/Oceania/FM.png": "23ef",
	"./static/imagev2/Oceania/GU.png": "bc4b",
	"./static/imagev2/Oceania/KI.png": "2f5f",
	"./static/imagev2/Oceania/MH.png": "158b",
	"./static/imagev2/Oceania/NR.png": "20fe",
	"./static/imagev2/Oceania/NZ.png": "5158",
	"./static/imagev2/Oceania/PF.png": "85e9",
	"./static/imagev2/Oceania/PG.png": "8215",
	"./static/imagev2/Oceania/PW.png": "c42d",
	"./static/imagev2/Oceania/SB.png": "479a",
	"./static/imagev2/Oceania/TO.png": "5781",
	"./static/imagev2/Oceania/TV.png": "d9d4",
	"./static/imagev2/Oceania/WS.png": "adbc",
	"./static/imagev2/South America/AR.png": "e78d",
	"./static/imagev2/South America/BO.png": "1e00",
	"./static/imagev2/South America/BR.png": "6c1c",
	"./static/imagev2/South America/CL.png": "24c6",
	"./static/imagev2/South America/CO.png": "62de",
	"./static/imagev2/South America/EC.png": "baf0",
	"./static/imagev2/South America/FK.png": "d545",
	"./static/imagev2/South America/GF.png": "df71",
	"./static/imagev2/South America/GY.png": "c942",
	"./static/imagev2/South America/KN.png": "b06e",
	"./static/imagev2/South America/PE.png": "ff2d",
	"./static/imagev2/South America/PY.png": "a9a6",
	"./static/imagev2/South America/SR.png": "84d0",
	"./static/imagev2/South America/UY.png": "3f8d",
	"./static/imagev2/South America/VC.png": "e38a",
	"./static/imagev2/South America/VE.png": "774f",
	"./static/imagev2/undefined.png": "ad95",
	"./static/imagev2/zanwutupian.png": "ac3e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8e1";